<template>
  <span
    class="inline-flex shrink-0 items-center justify-center rounded-full border border-amber-300/35 bg-amber-300/15 text-amber-100 shadow-[0_6px_20px_rgba(245,158,11,0.22)]"
    :class="sizeClass"
    :title="title"
    aria-label="Official photographer"
  >
    <svg viewBox="0 0 24 24" class="h-[70%] w-[70%]" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
      <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6H9l1.2-1.8a1 1 0 0 1 .82-.44h2a1 1 0 0 1 .82.44L15 6h2.5A2.5 2.5 0 0 1 20 8.5v8A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5z" />
      <circle cx="12" cy="12.5" r="3.5" />
      <path d="M8 8h.01" stroke-linecap="round" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'PhotographerBadge',
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    title: {
      type: String,
      default: 'Official photographer',
    },
  },
  computed: {
    sizeClass() {
      if (this.size === 'xs') return 'h-4 w-4'
      if (this.size === 'lg') return 'h-7 w-7'
      return 'h-5 w-5'
    },
  },
}
</script>
